import React from "react";
import { FormControl, Paper } from "@mui/material";
import { useDispatch } from "react-redux";
import { translate } from "../../../../../../common/providers";
import styles from "./RedressDialog.module.css";
import { setDisableKeyEvents } from "../../../../../../common/slice";
import { CustomTextField, Selector } from "../../../../../../common/components";

export default function RedressContent({
	action,
	CONTENT_TYPES,
	error,
	handleChangeAction,
	handleChangeToc,
	handleChangeType,
	REDRESS_ACTION,
	selectedBlock,
	toc,
	type,
}) {
	const dispatch = useDispatch();
	const getDirectionLabel = (selected) =>
		translate(
			selected === REDRESS_ACTION[0]
				? "smart-review.redress-content.item-same-level-as-previous-clause"
				: "smart-review.redress-content.item-under-prev-clause"
		);
	return (
		<>
			<div className={styles.container}>
				<Paper className={styles.paper}>
					<span className={styles.content}>{selectedBlock?.contentType}</span>
				</Paper>
				<Paper className={styles.paper}>
					<Selector
						className={styles.content}
						items={CONTENT_TYPES.filter((contentType) => contentType !== selectedBlock?.contentType)}
						menuClassName={styles.select}
						size="sm"
						value={type || ""}
						onChange={handleChangeType}
					/>
				</Paper>
			</div>
			{selectedBlock?.contentType === "PARAGRAPH" ? (
				<div className={styles.container}>
					<Paper className={styles.paper}>
						<Selector
							className={styles.content}
							itemRenderer={getDirectionLabel}
							items={REDRESS_ACTION}
							label={translate("smart-review.redress-content.redress-direction")}
							menuClassName={styles.select}
							size="sm"
							value={action || REDRESS_ACTION[0]}
							valueRenderer={getDirectionLabel}
							onChange={handleChangeAction}
						/>
					</Paper>
				</div>
			) : null}
			{selectedBlock?.contentType === "PARAGRAPH" ? (
				<div className={styles.container}>
					<Paper className={styles.paper}>
						<FormControl className={styles.content}>
							<CustomTextField
								error={error || false}
								helperText={error && translate("smart-review.redress-content.label.mandatory-entry")}
								label={translate("smart-review.redress-content.label.new-toc")}
								size="small"
								value={toc || ""}
								variant="outlined"
								onBlur={() => dispatch(setDisableKeyEvents(false))}
								onChange={handleChangeToc}
								onFocus={() => dispatch(setDisableKeyEvents(true))}
							/>
						</FormControl>
					</Paper>
				</div>
			) : null}
		</>
	);
}
